<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span>
              {{
                this.$t('report.company_dashboard.reports')
              }}
            </span>
          </li>
          <li>{{ this.$t('general.content_reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span>{{ this.$t('general.content_reports') }}</span>
        </h2>
      </div>
    </div>

    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">

          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>

          <div class="d-flex">

            <!-- Filter -->
            <filter-dropdown-button @reset="resetFilter" @filter="filterResult">
              <div class="uk-child-width-1-2@s uk-grid-small" uk-grid>

                <!-- İçerik -->
                <app-multiselect v-model="contentIds" :allow-empty="true" :is-multiple="true" :options="contentList"
                  label="name" :placeholder="$t('general.select_content')" :title="$t('general.content')" />

                <!-- İçerik Türü -->

                <app-multiselect v-model="contentTypeIds" :allow-empty="true" :is-multiple="true"
                  :options="contentTypeOptions" label="name" :placeholder="$t('general.select_content_type')"
                  :title="$t('general.content_type')" />

              </div>
            </filter-dropdown-button>

            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>

            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'title')">
                    {{ $t("sorting.a_z") }}
                  </a>
                </li>

                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'title')">
                    {{ $t("sorting.z_a") }}
                  </a>
                </li>

                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}
                  </a>
                </li>

                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}
                  </a>
                </li>
              </ul>
            </div>

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
              @download="exportContents" />

          </div>
        </div>
      </div>

      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>

      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("users.photo") }}</th>
                <th scope="col">ID</th>
                <th scope="col">{{ $t('general.content_title') }}</th>
                <th scope="col">{{ $t('general.content_code') }}</th>
                <th scope="col">{{ $t('general.duration') }}(dk)</th>
                <th scope="col">{{ $t('excel.heading.category') }}</th>
                <th scope="col">{{ $t('general.assigned_user') }}</th>
                <th scope="col">
                  {{ $t('general.number_of_users_havent_started') }}
                </th>
                <th scope="col">
                  {{ $t('general.number_of_users_continue') }}
                </th>
                <th scope="col">
                  {{ $t('general.number_of_users_completed') }}
                </th>
                <th scope="col">{{ $t('general.detail') }}</th>
              </tr>
            </thead>

            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">
                      <div>
                        <div class="avatar-parent-child" style="width: max-content">
                          <img :alt="item.name" :src="item.photo_link" class="avatar rounded-circle" />
                        </div>
                      </div>
                    </div>
                  </th>

                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.duration }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.total_user }}</td>
                  <td>{{ item.not_started_users }}</td>
                  <td>{{ item.started_users }}</td>
                  <td>{{ item.completed_users }}</td>

                  <td>
                    <button aria-expanded="false" class="btn btn-icon btn-hover btn-sm btn-circle" type="button"
                      @click="gotoContentDetail(item)" :disabled="!$hasPermission('read_contentdetailreport')" :style="{
                        cursor: !$hasPermission('read_contentdetailreport')
                          ? 'not-allowed'
                          : 'pointer'
                      }" :uk-tooltip="!$hasPermission('read_contentdetailreport')
  ? $t('general.no_permission')
  : $t('general.detail')
  ">
                      <i class="uil-eye text-danger" />
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  ERROR,
  GET_ITEMS,
  ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import axios from "axios";

import Pagination from "@/assets/components/Pagination";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import FilterDropdownButton from "@/view/components/filter/FilterDropdownButton.vue";
import { showError, showInfo } from "@/utils/alertUtils.js";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import { CONTENT_TYPES } from "@/core/constant/content-types";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportUsers",

  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },

  components: {
    ExcelDownloadButton,
    Pagination,
    UserProfile,
    DefaultLoading,
    AppMultiselect,
    FilterDropdownButton,
  },

  data() {
    return {
      pagination: null,
      activeItem: null,

      page: 1,
      per_page: 10,

      sort_by: "id",
      sort_desc: "desc",

      formattedItems: [],

      /*
       * Filtreler
       */
      contentIds: [],
      contentList: [],

      contentTypeIds: [],
      contentTypeList: [],

      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },

      successMessage: "",
      isReportDownloading: false,
    };
  },

  computed: {
    contentTypeOptions() {
      return CONTENT_TYPES
        .filter((item) => item.id !== 11)
        .map((item) => ({
          id: item.id,
          name: this.$t(item.key_name),
        }));
    },
    items: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ITEMS];
      },
      set(value) { },
    },

    user_loading: {
      get() {
        return store.getters[_MODULE_NAME + "/" + LOADING];
      },
      set(value) { },
    },

    errors: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },

    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },

  methods: {

    gotoContentDetail(item) {
      this.$router.push({
        name: "company.contents.detail",
        params: {
          id: item.id,
        },
      });
    },

    /*
     * İçerik listesini getirir
     *
     * GET /api/report/get-contents
     * sort=desc
     * order_by=id
     * program=true
     * sections=false
     * all=true
     */
    getContents() {
      const filters = {
        sort: "desc",
        order_by: "id",
        sections: false,
        all: true,
        exam: true,
        survey: true,
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/get-contents",
          filters: filters,
        })
        .then((response) => {
          if (response.status) {
            this.contentList = [];

            let items = response.data;

            if (items && items.data) {
              items = items.data;
            }

            if (Array.isArray(items)) {
              items.forEach((item) => {
                this.contentList.push({
                  id: item.id,
                  name: item.title || item.name,
                });
              });
            }
          }
        });
    },

    /*
     * İçerik türlerini getirir
     *
     * GET /api/content/file-category?exam=true
     */
    getContentTypes() {
      const filters = {
        exam: true,
        survey: true,
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/content/file-category",
          filters: filters,
        })
        .then((response) => {
          if (response.status) {
            this.contentTypeList = [];

            let items = response.data;

            if (items && items.data) {
              items = items.data;
            }

            if (Array.isArray(items)) {
              items.forEach((item) => {
                this.contentTypeList.push({
                  id: item.id,
                  name: item.name,
                });
              });
            }
          }
        });
    },
    /*
     * Excel export
     *
     * Seçilen içerik ve içerik türü filtreleri
     * Excel API'sine de gönderilir.
     */
    exportContents() {
      if (this.isReportDownloading) {
        return;
      }

      this.isReportDownloading = true;

      const content_ids = this.contentIds.map((item) => item.id);
      const file_category_ids = this.contentTypeIds.map((item) => item.id);

      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL +
          "/api/report/export/contents",
          {
            params: {
              sort: this.filter.sort,
              order: this.filter.order,
              like: this.filter.search,

              content_ids: JSON.stringify(content_ids),
              file_category_ids: JSON.stringify(file_category_ids),

              report: Math.random() * 9999999,
            },

            headers: this.apiHeaders,
          }
        )
        .then((response) => {
          this.isReportDownloading = false;

          showInfo(response.data.data);
        })
        .catch((error) => {
          this.isReportDownloading = false;

          showError(error);
        });
    },

    filterResult(filter = null) {
      let self = this;

      const content_ids = this.contentIds.map((item) => item.id);
      const file_category_ids = this.contentTypeIds.map((item) => item.id);

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
        content_ids: JSON.stringify(content_ids),
        file_category_ids: JSON.stringify(file_category_ids),
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/contents",
          filters: filters,
        })
        .then((response) => {
          self.formattedItems = [];

          if (response.status) {
            let items = response.data;

            this.pagination = items;

            items.data.forEach((item) => {
              let total_user = 0;

              item.assignments.forEach((assignment) => {
                total_user += assignment.users_count;
              });

              self.formattedItems.push({
                id: item.id,
                name: item.title,
                photo_link: item.cover_photo_link,
                code: item.code ?? "-",
                duration: item.duration
                  ? item.duration + " dk"
                  : "-",
                total_user: total_user,
                not_started_users: Math.max(
                  0,
                  total_user -
                  item.started_users -
                  item.completed_users
                ),
                started_users: item.started_users,
                completed_users: item.completed_users,
                category: item.content_category
                  ? item.content_category.name
                  : "-",
              });
            });
          }
        });
    },

    sortOrder(order, sort) {
      this.page = 1;

      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },

    setPage(page) {
      this.page = page;

      this.filterResult();
    },

    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },

    getFilter(value) {
      this.page = 1;

      this.filterResult(value);
    },

    /*
     * Filtreleri temizle
     */
    resetFilter() {
      this.contentIds = [];
      this.contentTypeIds = [];

      this.page = 1;

      this.filterResult();
    },
  },

  mounted() {
    /*
     * Rapor listesi
     */
    this.filterResult();

    /*
     * Filtre dropdown verileri
     */
    this.getContents();
    this.getContentTypes();

    this.debouncedFilterSearch = _.debounce(
      this.filterResult,
      500
    );

    if (this.$route.params.succesMessage != null) {
      this.successMessage = this.$route.params.succesMessage;
      this.scrollToTop();
    }
  },

  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },

    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },

    formattedInstitution(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker1").selectpicker();
        }, 200);
      }
    },

    formattedUserGroup(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker2").selectpicker();
        }, 200);
      }
    },

    formattedPosition(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker3")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },

    formattedTitle(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker4")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },

    formattedRegion(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker5")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },

    formattedDepartment(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker6")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },

    formattedBranch(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker7")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },

    activeItem(value) {
      if (value) {
        this.getUserDetail(value.id);
      }
    },
  },

  beforeDestroy() {
    const modal = UIkit.modal("#modal-profile");

    if (modal) {
      modal.$destroy(true);
    }
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>